import { EventSearchPage } from './../event/main/event-search/event-search';
import { PremiumPaymentPage } from './../premium/premium-payment/premium-payment';
import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, Platform, LoadingController, NavController, NavParams, ActionSheetController, ModalController, Tabs } from 'ionic-angular';
import { CategoriesProvider } from '../../providers/categories/categories';
import { ConfigProvider } from '../../providers/config/config';
import { UserProvider } from '../../providers/user/user';
import { LoginPage } from '../login/login/login';
import { ResultSearchPage } from '../results/result-search/result-search';
import { SessionProvider } from '../../providers/session/session';
import { PrivateProfilePage } from '../me/settings/private-profile/private-profile';
import { ValueProvider } from '../../providers/value/value';
import { NotificationPage } from '../notification/main/notification';
import { TutorialProvider } from '../../providers/tutorial/tutorial';
import { NewsController } from '../../providers/news/news-contoller';
import { LoaderProvider } from '../../providers/loader/loader';
import { Diagnostic } from '@ionic-native/diagnostic';
import { IdRegistrationPage } from '../login/id-registration/id-registration';
import { TrackPage } from '../../tracker/track-page/trackpage';
import { AppDetectorProvider } from '../../providers/detector/detector';
import { MysportUserProfilePage } from '../me/mysport/mysport-user-profile/mysport-user-profile';
import { ResultTeamsPage } from '../results/result-teams/result-teams';
import { LeaderTrack } from '../../tracker/leader-track-page/leader-track';
import { EventActivityTabsPage } from '../event/event-activity-tabs/event-activity-tabs';
import { LineupPage } from '../apps/lineup/lineup';
import { GamerTeamsPage } from '../apps/gamer/pages/team-list/gamer-teams';
import { TouListPage } from '../apps/gamer/pages/tou-list/tou-list';
import { PlanResultsMainPage } from '../apps/gamer/pages/results/main/plan-result-main';
import { NewTouMainPage } from '../apps/gamer/pages/new-tou/new-tou-main';
import { TournamentService } from '../apps/gamer/services/tournament.service';
import { GeolocationService } from '../../providers/geolocation-service/geolocation-service';
import { AnmeldungenPage } from '../anmeldungen-page/anmeldungen-page';
import { EventsLauncherService } from '../../providers/events-launcher.service';
import { EventsLauncherPage } from '../events-launcher/events-launcher';
import { PremiumBannerPage } from '../premium/premium-banner/premium-banner';
import { Subscription } from 'rxjs';
import { DarkMode, ThemeMode } from '../../providers/dark-mode/dark-mode';

@Component({
  templateUrl: 'tabs.html',
  selector: 'tabs-main'
})
export class TabsPage {
  displayMaps: boolean = false;
  lauftreffApp: boolean = false;
  tabsNews: boolean = false;
  onComeBack: boolean = false;
  newTouPage: boolean = true;
  seltabix: number = 0;
  views: any;
  appName: string = "";

  // darkmode
  toDarkSub:Subscription;
  isDark:boolean=false;

  // used to show/hide the tutorial only for hannover app
  // TODO SWITCH 
  firstrun: boolean = true;
  tutorial: boolean = false;
  tutorialForest: boolean = false;
  tutorial_page: number = 0;
  //

  //UI
  reloadTrigger: boolean = true;
  isHella: boolean = false;
  resultsPage: boolean = true;
  iconTrnName: string = "appname-training";
  iconRecName: string = "appname-record";
  iconMeName: string = "appname-me";
  iconTshirtNameBlue: string = "appname-tshirt";
  iconFieldBlue: string = "appname-field";
  currentPage: string;
  redirectPermission: boolean = true;
  isBrowser: boolean = false;

  tab1Root: any = EventSearchPage;
  tab2Root: any = MysportUserProfilePage;
  tab3Root: any = ResultSearchPage;
  tab4Root: any = TrackPage;
  tab5Root: any = EventActivityTabsPage;
  tab6Root: any = ResultTeamsPage;
  tab7Root: any = NotificationPage;
  tab8Root: any = LeaderTrack;
  tab9Root: any = GamerTeamsPage;
  tab10Root: any = LineupPage;
  tab11Root: any = NewTouMainPage;
  tab12Root: any = PlanResultsMainPage;
  tab13Root: any = TouListPage;
  tab14Root: any = AnmeldungenPage;

  selectedTab: number = 2;
  @ViewChild('mainTabs') tabRef: Tabs;

  constructor(
    public app: App,
    private gs: TournamentService,
    public navCtrl: NavController,
    public translate: TranslateService,
    private userService: UserProvider,
    private platform: Platform,
    private config: ConfigProvider,
    private categoryService: CategoriesProvider,
    private loadingCtrl: LoadingController,
    public sessionService: SessionProvider,
    private valueService: ValueProvider,
    private tutorialProvider: TutorialProvider,
    private geoService: GeolocationService,
    private navParams: NavParams,
    private modalCtrl: ModalController,
    private appDetector: AppDetectorProvider,
    private darkModeService: DarkMode
  ) {
    new Promise(async (resolve, reject) => {
      this.appName = (await this.config.config).appId;
      // this.isBrowser = (await this.config.config).platform.browser;
      this.lauftreffApp = (await this.config.config).showHide.lauftreff;
      this.tabsNews = (await this.config.config).showHide.tabsNews;
      this.tutorial = (await this.config.config).showHide.hannoverTutorial;
      this.tutorialForest = (await this.config.config).showHide.tutorialForest;
      this.resultsPage = (await this.config.config).showHide.resultsPage;

      this.redirectPermission = (await this.config.config).showHide.redirectPermission;
      this.newTouPage = !!!this.gs.planList.length;
      this.onComeBack = this.navParams.get("onComeBack");
      this.seltabix = this.navParams.get("openTab");
      this.views = this.navParams.get("views");

      this.isHella = this.appName.includes("hella") ? true : false;
      this.iconMeName = this.appDetector.isForestApp() ? "beard-me" : "appname-me";

      this.tutorialProvider.isFirstRun().then(data => {
        this.firstrun = data;
        resolve(null);
      });
      resolve(null);
    });
  }
  ngOnInit() {
    this.toDarkSub = this.darkModeService.themeModeSubject.subscribe((mode: ThemeMode) => {
      this.isDark = (mode === ThemeMode.DarkMode);
      let body = <HTMLElement>document.querySelector('body');

      if (this.isDark && !body.classList.contains(ThemeMode.DarkMode)) {
        body.classList.add(ThemeMode.DarkMode);
      } else if (!this.isDark && body.classList.contains(ThemeMode.DarkMode)) {
        body.classList.remove(ThemeMode.DarkMode);
      }
    });
  }

  preloadClientData() {
    let loader = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });

    loader.present();

    this.valueService.getProfileBackgrounds().then(backgrounds => {

      NewsController.getInstance().isAllowed = false;
      (this.app.getActiveNav() as NavController)
        .push(MysportUserProfilePage, {
          data: { profile: this.sessionService.profile, backgrounds: backgrounds }
        })
        .then(() => loader.dismiss());
    });
  }

  tapped() {
    let view = this.app.getActiveNav().getViews()[0].name;
  }

  reload() {
    this.reloadTrigger = false;
    setTimeout(() => {
      this.reloadTrigger = true
    });
  }

  onLoadMap() {
    this.navCtrl.setPages(this.views);
    this.navCtrl.pop();
  }

  ngAfterViewInit() {
    this.platform.ready().then(() => {
      this.config.config.then(config => {
        this.displayMaps = config.showHide.liveMaps;
      });

      this.sessionService.onRequestPageLogin().subscribe((promise) => {
        this.showLogin(promise);
      });

      this.sessionService.onRequestLogout().subscribe(() => {
        this.updateMeIcon();
        this.geoService.stopPlugin();
      });

      this.sessionService.onRequestLoggedIn().subscribe(() => {
        this.updateMeIcon();
      });

      this.gs.$planListChangeSub.subscribe(() => {
        console.log('-----planListChangeSub-----');
        this.newTouPage = !!!this.gs.planList.length;
        this.reload();
        setTimeout(() => {
          this.app.getRootNav().getActiveChildNav().select(1);
          console.log('-----redirect to the tab(1)-----');
        }, 50);
      });

      this.sessionService.onRequestPageProfileEdit().subscribe(() => {

        if (!this.redirectPermission) return;
        let l = (this.app.getRootNav() as NavController).getViews();
        if (l.find(x => x.component === PrivateProfilePage)) return;

        let loader = this.loadingCtrl.create({
          content: this.translate.instant('GLOBAL_LOADING')
        });
        loader.present();

        Promise.all([
          this.valueService.getProfileTitles(),
          this.valueService.getProfileTypes(),
          this.valueService.getCountries(),
          this.categoryService.getProfileCategoires(),
          this.valueService.getProfileBackgrounds()
        ]).then(values => {
          (this.app.getRootNav() as NavController)
            .push(PrivateProfilePage, {
              data: {
                titles: values[0],
                types: values[1],
                countries: values[2],
                categories: values[3],
                photos: [],
                backgrounds: values[4],
                profile: this.sessionService.profile
              }
            })
            .then(() => loader.dismiss());
        });
      });

      let loader = this.loadingCtrl.create({
        content: ''
      });
      loader.present();
      Promise.all([this.categoryService.getAllCategories(), this.userService.checkLoged()]).then(() => {
        if (this.appDetector.isLeaderBoardApp()) this.app.getRootNav().getActiveChildNav().select(0);
        loader.dismiss();
      });
    });

    //this.config.urlConfig().then((data) => console.log(data));
  }

  public profileImage(): string {
    return this.sessionService.profile.profilePicLink || 'assets/imgs/default-image-32@1x.png';
  }

  showLogin(promise = { resolve: null }) {
    if (this.isHella) {
      // IdRegistrationPage ORIGINAL_RETURN
      this.app.getRootNav().push(IdRegistrationPage);
    } else {
      this.app.getRootNav().push(LoginPage, { resolve: promise.resolve });
    }
  }

  getFirstRun() {
    return this.firstrun;
  }

  ionViewWillLeave() {
    this.onComeBack = false;

    this.reload();
  }

  fillTrnIcon() {
    if (!this.tutorialProvider.isLoginAllowed) {
      this.iconTrnName = this.appDetector.isLeaderBoardApp() ? "appname-training-filled-blue" : "appname-training-filled";
      return;
    }
    if (!this.sessionService.isLoged) {
      console.log('log',!this.sessionService.isLoged)
      this.app.getRootNav().getActiveChildNav().select(0);
      new Promise<any>((resolve, reject) => {
        (this.app.getRootNav() as NavController).push(LoginPage, { resolve: resolve });
      }).then((status) => {
        if (status) {
          // TEMPORARY FIX 2 -> 3
          this.app.getRootNav().getActiveChildNav().select(3);
        }
      })
    } else {
      // TEMPORARY FIX 2 -> 3
      this.app.getRootNav().getActiveChildNav().select(3);
    }

    this.iconTrnName = this.appDetector.isLeaderBoardApp() ? "appname-training-filled-blue" : "appname-training-filled";
    this.iconTshirtNameBlue = "appname-tshirt";
    this.iconRecName = "appname-record";
    this.iconMeName = this.appDetector.isForestApp() ? "beard-me" : "appname-me";

    this.iconFieldBlue = "appname-field";
  }

  updateMeIcon() {
    let iconElement;
    if (this.platform.is('android')) {
      iconElement = document.getElementsByClassName('ion-md-appname-me')[0];
      if (typeof iconElement === "undefined") {
        let className = (this.appDetector.isForestApp()) ? "ion-md-appname-me-filled-green" : this.appDetector.isGesunderApp() ? "ion-md-appname-me-filled-black" : "";
        iconElement = document.getElementsByClassName(className)[0];
      }
    } else if (this.platform.is('ios')) {
      iconElement = document.getElementsByClassName('ion-ios-appname-me-outline')[0];
      if (typeof iconElement === "undefined") {
        let className = (this.appDetector.isForestApp()) ? "ion-ios-appname-me-filled-green" : this.appDetector.isGesunderApp() ? "ion-ios-appname-me-filled-black" : "";
        iconElement = document.getElementsByClassName(className)[0];
      }
    }
    iconElement = document.getElementsByClassName('user-image-m')[0];
    if (typeof iconElement !== "undefined") {
      if (this.sessionService.isLoged) {
        iconElement.style.background = "url(" + (this.sessionService.profile.profilePicLink || 'assets/imgs/default-image-32@1x.png') + ") no-repeat";
        iconElement.style.height = "28px";
        iconElement.style.width = "28px";
        iconElement.style.borderRadius = "50px";
        iconElement.style.backgroundSize = "cover";
        iconElement.style.backgroundPosition = "center";
      }
      else {
        iconElement.style.background = "";
        iconElement.style.height = "";
        iconElement.style.width = "";
        iconElement.style.borderRadius = "";
        iconElement.style.backgroundSize = "";
        iconElement.style.backgroundPosition = "";
      }
    }
  }

  fillRecIcon() {
    if (!this.tutorialProvider.isLoginAllowed) {
      this.iconRecName = (this.appDetector.isTournamentApp() || this.appDetector.isLeaderBoardApp()) ? "appname-record-filled-blue" : "appname-record-filled";
      return;
    }
    
    if (this.sessionService.isLoged && this.appDetector.isLeaderBoardApp()) {
      this.app.getRootNav().getActiveChildNav().select(2);
    } else if (this.sessionService.isLoged && this.appDetector.isForestApp()) {
      this.app.getRootNav().getActiveChildNav().select(2);
      this.presentPremiumPage();
    }else if(this.appDetector.isTournamentApp()){
      this.sessionService.getTokenAndNavigate(false, false).then(token => {
        this.gs.getPlanList().then((t) => {
          this.newTouPage = !!!this.gs.planList.length;
          this.app.getRootNav().getActiveChildNav().select(4);
        });
      })
    } else {
      new Promise<any>((resolve, reject) => {
        (this.app.getRootNav() as NavController).push(LoginPage, { resolve: resolve });
      }).then((status) => {
        if (status) {
          let pageIndex = this.appDetector.isTournamentApp() ? 4 : 2;
          this.app.getRootNav().getActiveChildNav().select(pageIndex);
        }
      })
    }


    this.iconRecName = (this.appDetector.isTournamentApp() || this.appDetector.isLeaderBoardApp()) ? "appname-record-filled-blue" : "appname-record-filled";
    this.iconTrnName = "appname-training";
    this.iconMeName = this.appDetector.isForestApp() ? "beard-me" : "appname-me";
    this.iconFieldBlue = "appname-field";
    this.iconTshirtNameBlue = "appname-tshirt";
  }

  presentPremiumPage() {
    if (this.sessionService.isLoged && this.sessionService.profile && this.sessionService.profile.premium) return;

    let modalCtrl = this.modalCtrl.create(PremiumBannerPage);

    modalCtrl.present();
    modalCtrl.onDidDismiss((res) => {
      if (res) {
        let newModal = this.modalCtrl.create(PremiumPaymentPage);
        newModal.present();
      }
    });
  }

  fillMeIcon() {
    // this.iconMeName = (this.appDetector.isForestApp()) ? "appname-me-filled-green" : this.appDetector.isGesunderApp() ? "appname-me-filled-black" : "";
    // this.iconMeName = (this.appDetector.isForestApp()) ? "appname-me-filled-green" : this.appDetector.isGesunderApp() ? "appname-me-filled-black" : "";
    if (this.appDetector.isForestApp()) {
      this.iconMeName = "beard-me";
    } else if (this.appDetector.isGesunderApp()) {
      this.iconMeName = "appname-me-filled-black";
    } else if (this.appDetector.isTournamentApp() || this.appDetector.isLeaderBoardApp()) {
      this.iconMeName = "appname-me-filled-blue";
    }
    this.iconTrnName = "appname-training";
    this.iconRecName = "appname-record";
    this.iconFieldBlue = "appname-field";
    this.iconTshirtNameBlue = "appname-tshirt";
  }

  fillTshirtIcon() {
    this.iconTshirtNameBlue = "appname-tshirt-filled-blue";
    this.iconTrnName = "appname-training";
    this.iconMeName = "appname-me";
    this.iconFieldBlue = "appname-field";
    this.iconRecName = "appname-record";
    if (this.appDetector.isTournamentApp()) {
      this.sessionService.getTokenAndNavigate(false, false).then(token => {
        this.gs.getPlanList().then((t) => {
          this.newTouPage = !!!this.gs.planList.length;
          this.app.getRootNav().getActiveChildNav().select(2);
        });
      });
    }
  }

  fillFieldIcon() {
    this.iconFieldBlue = 'appname-field-filled';
    this.iconTrnName = "appname-training";
    this.iconMeName = "appname-me";
    this.iconTshirtNameBlue = "appname-tshirt";
    this.iconRecName = "appname-record";
    if (this.appDetector.isTournamentApp()) {
      this.sessionService.getTokenAndNavigate(false, false).then(token => {
        this.gs.getPlanList().then((t) => {
          this.newTouPage = !!!this.gs.planList.length;
          this.app.getRootNav().getActiveChildNav().select(3);
        });
      });
    }
  }

  setIconsDefault() {
    this.iconTrnName = "appname-training";
    this.iconRecName = "appname-record";
    this.iconMeName = this.appDetector.isForestApp() ? "beard-me" : "appname-me";
    this.iconTshirtNameBlue = "appname-tshirt";
    this.iconFieldBlue = "appname-field";

    this.updateMeIcon();
  }

  touListTabPressed() {
    this.iconTrnName = "appname-training";
    this.iconRecName = "appname-record";
    this.iconMeName = "appname-me";
    this.iconTshirtNameBlue = "appname-tshirt";
    this.iconFieldBlue = "appname-field";

    this.updateMeIcon();
    if (this.appDetector.isTournamentApp()) {
      this.sessionService.getTokenAndNavigate(false, false).then(token => {
        this.gs.getPlanList().then((t) => {
          this.newTouPage = !!!this.gs.planList.length;
          this.app.getRootNav().getActiveChildNav().select(1);
        });
      });
    }
  }

  setEventsTab() {
    this.selectedTab = 0;
    this.loginGuard();
    this.setIconsDefault();
  }

  setErgenisseTab() {
    this.selectedTab = 1;
    this.loginGuard();
    this.setIconsDefault();
  }

  loginGuard() {
    if (!this.sessionService.isLoged) {
      this.app.getRootNav().push(LoginPage, { selectedTab: this.selectedTab });
      this.app.getRootNav().getActiveChildNav().select(this.tabRef.previousTab());
      return;
    }
  }
}



// WEBPACK FOOTER //
// /src/pages/tabs/tabs.ts